import React from 'react';
import type { LinkProps as NextLinkProps } from 'next/link';
import { Link } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';
import { IconCarretRight } from '@src/assets/icon-carret-right';

interface ShowAllTitleProps {
  title: string;
  linkText?: string;
  link: NextLinkProps['href'];
  newTab?: boolean;
}

export const ShowAllTitle = ({ title, linkText = 'Alle ansehen', link, newTab }: ShowAllTitleProps) => {
  if (!title || title === '') return null;
  return (
    <Link noLink={!link} href={link} target={newTab ? '_blank' : '_self'}>
      <div
        className={twMerge(
          'relative z-10 mb-3 flex items-center overflow-hidden font-herokid text-xl font-bold text-foreground',
          !!link && 'group cursor-pointer',
        )}
      >
        {title}
        {!!link && (
          <div className="relative ml-1 inline-grid h-full grid-cols-[0fr,auto] content-start items-center justify-start overflow-hidden whitespace-nowrap text-left text-2xs uppercase tracking-widest transition-all duration-300 group-hover:grid-cols-[1fr,auto] group-hover:text-primary">
            <div className="grid justify-end overflow-hidden pl-0 transition-all duration-300 group-hover:pl-1">
              {linkText}
            </div>
            <IconCarretRight />
          </div>
        )}
      </div>
    </Link>
  );
};
